
import { AbstractDestroyable, memone, VoidCallback } from '@deqo/foundation';
import {
    ClientRef,
    EventRouter,
    ModelMutateCallback,
    ModelMutation,
    ModelView,
    PodSessionStartRoutine,
    PresencePatch,
    RecordData,
    SnapshotData,
    TopicData,
    TopicValues
} from '@deqo/podopolis';

export class StaticEditorPodSession extends AbstractDestroyable {// implements EditorPodSession {

    private refs = new Map<string, ClientRef>();
    private streams = new EventRouter<any>();

    constructor(private snapshot: SnapshotData) {
        super();
    }

    public getMutation(): ModelMutation {
        return null;
    }

    @memone()
    public getModel(): ModelView {
        return ModelView.create(this.snapshot);
    }

    public getTime(): number {
        return 0;
    }

    public mutate(_impl: ModelMutateCallback): boolean {
        // throw new Error('Cannot mutate a static session.');
        return false;
    }

    public on(type: any, to: any): VoidCallback {
        return this.streams.on(type, to);
    }

    public getPodId(): string {
        return null;
    }

    public start(): Promise<void> {
        return Promise.resolve();
    }

    protected onInit(_startRoutine: PodSessionStartRoutine): void {
    }

    protected createRef(clientId: string): ClientRef {
        if (!this.refs.has(clientId)) {
            this.refs.set(clientId, { id: clientId, userId: null, instanceId: null });
        }
        return this.refs.get(clientId);
    }

    protected releaseRef(clientId: string): void {
        this.refs.delete(clientId);
    }

    public getClients(): ClientRef[] {
        return [this.getThisClient()];
    }

    public getClient(clientId: string): ClientRef {
        return this.createRef(clientId);
    }

    public getClientProfile(_clientId: string): Readonly<Record<string, any>> {
        return {};
    }

    public getClientProfileValue(_clientId: string, _key: string) {
        return null;
    }

    public getThisClient(): ClientRef {
        return this.createRef('self');
    }

    public getThisClientProfile(): Readonly<Record<string, any>> {
        return {};
    }

    public getThisClientProfileValue(_key: string) {
        return null;
    }

    public patchProfile(_patch: PresencePatch): void {
    }

    public sendRelay(_to: string, _data: any, _reductionKey?: string): void {
    }

    public hasTopicSubscription(_topic: string): boolean {
        return false;
    }

    public getTopicData(_topic: string): TopicData {
        return {};
    }

    public subscribeTopic(topic: string) {
        this.streams.emit('topicUpdate', [topic, {}, this.getThisClient()] as const);
    }

    public forgetTopic(_topic: string): void {
    }

    public broadcastTopic(_topic: string, _data: any): void {
    }

    public resetTopic(_topic: string, _data: TopicValues): TopicData {
        return {};
    }

    public patchTopic(_topic: string, _values: TopicValues): TopicData {
        return {};
    }

    public subscribeRecordSet(_recordSetName: string): void {

    }

    public getRecordSetNames(): string[] {
        return [];
    }

    public getRecordSet(_recordSetName: string): RecordData[] {
        return [];
    }

    public getRecord(_recordSetName: string, id: string): RecordData {
        return { id };
    }

    public patchRecord(_recordSetName: string, patch: RecordData): RecordData {
        return patch;
    }

}
